export default class ValidNewBusinessInceptionDateBoundaries {

	public earliestDateAllowed: Date | null = null;
	public latestDateAllowed: Date | null = null;

	public constructor() {

	}
};